import { Button, Stack, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";

const VIEW_LABELS = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
];

export function ScheduleCalendarToolbar({ label, onNavigate, onView, view }) {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems={{ xs: "stretch", md: "center" }}
      justifyContent="space-between"
      gap={2}
      sx={{ mb: 1 }}
    >
      <Stack direction="row" gap={1}>
        <Button size="small" variant="outlined" onClick={() => onNavigate("TODAY")}>
          Today
        </Button>
        <Button size="small" variant="outlined" onClick={() => onNavigate("PREV")}>
          ‹
        </Button>
        <Button size="small" variant="outlined" onClick={() => onNavigate("NEXT")}>
          ›
        </Button>
      </Stack>

      <Typography variant="h6" sx={{ textAlign: "center", color: "#111827" }}>
        {label}
      </Typography>

      <ToggleButtonGroup
        exclusive
        size="small"
        value={view}
        onChange={(event, nextView) => {
          if (nextView) {
            onView(nextView);
          }
        }}
        aria-label="Calendar view"
      >
        {VIEW_LABELS.map((item) => (
          <ToggleButton key={item.value} value={item.value}>
            {item.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  );
}
